module.exports = __webpack_public_path__ + "img/g.d3d113b5.jpg";